import React from 'react';
import { makeStyles } from 'tss-react/mui';

import { Typography } from '@mui/material';

import Utils from 'utils/Utils';

const useStyles = makeStyles()(() => ({
    root: {
        padding: 100,
        marginBottom: 50,
        background: '#fff',
        '@media (max-width: 1140px)': {
            padding: '100px 20px'
        },
        '@media (max-width: 720px)': {
            padding: '50px 20px 100px'
        }
    },
    box: {
        maxWidth: 960,
        margin: '40px auto',
        display: 'grid',
        columnGap: 20,
        gridTemplateColumns: 'repeat(4, 1fr)',
        justifyContent: 'center',
        paddingLeft: 80,
        '@media (max-width: 720px)': {
            margin: '30px auto',
            rowGap: 30,
            columnGap: 20,
            gridTemplateColumns: 'repeat(auto-fill, 142px)',
            paddingLeft: 0
        }
    },
    image: {
        maxWidth: 142,
        maxHeight: 32,
        filter: 'grayscale(100%)'
    }
}));

const Customers = ({ customClasses = {} }) => {
    const { classes } = useStyles();

    const customers1 = ['eu', 'acronis', 'cloudlinux', 'exness'];

    const customers2 = ['playrix', 'adobe', 'dg-cybersicherheit', 'alert-logic'];

    return (
        <div className={[classes.root, customClasses.customersRoot || ''].join(' ')} id="customers">
            <Typography style={{ fontSize: 48, marginBottom: 100 }} align="center" variant="h2">
                Trusted by
            </Typography>

            <div className={classes.box}>
                {customers1.map((customer) => (
                    <img
                        key={customer}
                        className={classes.image}
                        src={Utils.getImage('landing/' + customer)}
                        draggable={false}
                        alt={customer}
                    />
                ))}
            </div>

            <div className={classes.box}>
                {customers2.map((customer) => (
                    <img
                        key={customer}
                        className={classes.image}
                        src={Utils.getImage('landing/' + customer)}
                        draggable={false}
                        alt={customer}
                    />
                ))}
            </div>
        </div>
    );
};

export default Customers;
